import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';
import { getComponentClasses } from '@99designs/common/utils/app';
import { springConfig } from 'projects/util/spring';
import React from 'react';
import { Transition } from 'react-spring/renderprops';
import { DetachedOverlay } from './DetachedOverlay';

interface Props {
    showing: boolean;
    variations?: ['wide' | 'center'];
    onClose?: () => void;
}

interface State {
    animating: boolean;
}

export class DrawerOverlay extends React.Component<Props, State> {
    state = {
        animating: true,
    };

    static getDerivedStateFromProps(nextProps: Props) {
        // This ensures that when closing the overlay the background is showing while the animation
        // runs.
        if (nextProps.showing === false) {
            return { animating: true };
        }
        return {};
    }

    render() {
        return (
            <Transition
                items={this.props.showing}
                from={{ transform: 'translate(0,100vh)' }}
                enter={{ transform: 'translate(0,0px)' }}
                leave={{ transform: 'translate(0,100vh)' }}
                config={springConfig(300)}
                onRest={() => this.setState({ animating: false })}
            >
                {showing => props =>
                    showing && (
                        <DetachedOverlay isAnimating={this.state.animating}>
                            <div
                                className={getComponentClasses(
                                    'drawer-overlay',
                                    this.props.variations
                                )}
                                style={{ ...props }}
                            >
                                {this.props.onClose && (
                                    <div className="drawer-overlay__close">
                                        <IconButton onClick={this.props.onClose}>
                                            <div className="drawer-overlay__close__icon">
                                                <Icon type="x-3" />
                                            </div>
                                        </IconButton>
                                    </div>
                                )}
                                <div className="drawer-overlay__content">{this.props.children}</div>
                            </div>
                        </DetachedOverlay>
                    )}
            </Transition>
        );
    }
}
